import { createSlice } from '@reduxjs/toolkit';

const initialState = {
    studentFirstName_bil: '',
    studentLastName_bil: '',
    countryOfOrigin_bil: '',
    DOB_bil: '',
    gender_bil: '',
    yearsInUS_bil: '',
    grade_bil: '',
    childResidesWith_bil: '',
    mfg1_bil: '',
    mfgName1_bil: '',
    mfg2_bil: '',
    mfgName2_bil: '',
    childsResidesWithOther_bil: '',
    homeAddress_bil: '',
    homeNum_bil: '',
    workNum_bil: '',
    cellNum_bil: '',
    nativeLanguage_bil: '',
    nativeLanguageOther_bil: '',
    districtDropdown_bil: '',
    schoolDropdown_bil: '',
    CSEDate_bil: '',
    currentTeacherName_bil: '',
    currentTeacherEmail_bil: '',
    psychologistName_bil: '',
    psychologistEmail_bil: '',
    speechPathologistName_bil: '',
    speechPathologistEmail_bil: '',
    districtContactName_bil: '',
    districtContactTitle_bil: '',
    districtContactAddress_bil: '',
    districtContactPhone_bil: '',
    districtContactEmail_bil: '',
    approverName_bil: '',
    approverTitle_bil: '',
    approverEmail_bil: '',
    coser_bil: '',
    reason_bil: '',
    alreadyClassified_bil: false,
    classification_bil: '',

    consentToEvalAttached_bill: false,
    priorWrittenNoticeAttached_bil: false,
    homeLangQuestAttached_bil: false,
    nonVerbSecDiagnosed_bil: false,
    
    services_bil: [],
    notes_bil: '',
    studentEnterSchoolDate_bil: '',
    nameOfOtherSchoolAttended_bil: '',
    typesOfEvals_bil: [],
    typesOfEvals_other_bil: [],
    diagnosedCondition_bil: false,
    diagnosedConditionText_bil: '',
    generalHealth_bil: false,
    generalHealthText_bil: '',
    medication_bil: false,
    medicationText_bil: '',
    wearsGlasses_bil: false,
    wearsGlassesText_bil: '',
    pedRestrictions_bil: false,
    pedRestrictionsText_bil: '',
    physicalExamDate_bil: '',
    h_freq_audiology_bil: '',
    h_indv_audiology_bil: '',
    h_freq_visTherapy_bil: '',
    h_indv_visTherapy_bil: '',
    h_freq_resourceRoom_bil: '',
    h_indv_resourceRoom_bil: '',
    h_freq_counseling_bil: '',
    h_indv_counseling_bil: '',
    h_freq_speechLang_bil: '',
    h_indv_speechLang_bil: '',
    h_freq_physTherapy_bil: '',
    h_indv_physTherapy_bil: '',
    h_freq_occTherapy_bil: '',
    h_indv_occTherapy_bil: '',
    i_freq_Reading_bil: '',
    i_indv_Reading_bil: '',
    i_freq_AISMath_bil: '',
    i_indv_AISMath_bil: '',
    i_freq_AAtL_bil: '',
    i_indv_AAtL_bil: '',
    i_freq_AdjAssign_bil: '',
    i_indv_AdjAssign_bil: '',
    i_freq_schedAdj_bil: '',
    i_indv_schedAdj_bil: '',
    i_freq_indvProgBasedOnSkill_bil: '',
    i_indv_indvProgBasedOnSkill_bil: '',
    i_freq_speechImprov_bil: '',
    i_indv_speechImprov_bil: '',
    i_freq_tutoring_bil: '',
    i_indv_tutoring_bil: '',
    i_freq_consulServices_bil: '',
    i_indv_consulServices_bil: '',
    i_other_bil: '',
    areas_bil: [],
    addConcerns_bil: '',
    suspDetails_bil: '',

    docToAccessFiles_bil: [],
    consentToEvalAttachedFiles_bil: [],
    priorWrittenNoticeAttachedFiles_bil: [],
    homeLangQuestAttachedFiles_bil: [],

    page1ProgressBar: 0,
    page2ProgressBar: 0,
    page3ProgressBar: 0,
    backToInitialValues_bil: 0,
};

const assessmentSlice = createSlice({
    name: 'assessment',
    initialState,
    reducers: {
      studentFirstName_bilUpdated: (state, action) => {
        state.studentFirstName_bil = typeof action.payload === "string" ? action.payload : "";
      },
      studentLastName_bilUpdated: (state, action) => {
        state.studentLastName_bil = typeof action.payload === "string" ? action.payload : "";
      },
      countryOfOrigin_bilUpdated: (state, action) => {
        state.countryOfOrigin_bil = typeof action.payload === "string" ? action.payload : "";
      },
      DOB_bilUpdated: (state, action) => {
        let dateString = "";
        if (typeof action.payload === "string" || action.payload instanceof Date) {
          let temp = action.payload.toString().substring(0, 10);
          let temp2 = temp.split("-");
          if (temp2.length === 3) {
            dateString = temp2[0] + "-" + temp2[1] + "-" + temp2[2];
          }
        }
        state.DOB_bil = dateString;
      },
      gender_bilUpdated: (state, action) => {
        state.gender_bil = typeof action.payload === "string" ? action.payload : "";
      },
      yearsInUS_bilUpdated: (state, action) => {
        state.yearsInUS_bil = typeof action.payload === "string" ? action.payload : "";
      },
      grade_bilUpdated: (state, action) => {
        state.grade_bil = typeof action.payload === "string" ? action.payload : "";
      },
      childResidesWith_bilUpdated: (state, action) => {
        state.childResidesWith_bil = typeof action.payload === "string" ? action.payload : "";
        if (state.childResidesWith_bil !== "Other") {
          state.childsResidesWithOther_bil = "";
        }
      },
      mfg1_bilUpdated: (state, action) => {
        state.mfg1_bil = typeof action.payload === "string" ? action.payload : "";
      },
      mfgName1_bilUpdated: (state, action) => {
        state.mfgName1_bil = typeof action.payload === "string" ? action.payload : "";
      },
      mfg2_bilUpdated: (state, action) => {
        state.mfg2_bil = typeof action.payload === "string" ? action.payload : "";
      },
      mfgName2_bilUpdated: (state, action) => {
        state.mfgName2_bil = typeof action.payload === "string" ? action.payload : "";
      },
      childsResidesWithOther_bilUpdated: (state, action) => {
        state.childsResidesWithOther_bil = typeof action.payload === "string" ? action.payload : "";
      },
      homeAddress_bilUpdated: (state, action) => {
        state.homeAddress_bil = typeof action.payload === "string" ? action.payload : "";
      },
      homeNum_bilUpdated: (state, action) => {
        state.homeNum_bil = typeof action.payload === "string" ? action.payload : "";
      },
      workNum_bilUpdated: (state, action) => {
        state.workNum_bil = typeof action.payload === "string" ? action.payload : "";
      },
      cellNum_bilUpdated: (state, action) => {
        state.cellNum_bil = typeof action.payload === "string" ? action.payload : "";
      },
      nativeLanguage_bilUpdated: (state, action) => {
        state.nativeLanguage_bil = typeof action.payload === "string" ? action.payload : "";
        if (state.nativeLanguage_bil !== "Other") {
          state.nativeLanguageOther_bil = "";
        }
      },
      nativeLanguageOther_bilUpdated: (state, action) => {
        state.nativeLanguageOther_bil = typeof action.payload === "string" ? action.payload : "";
      },
      districtDropdown_bilUpdated: (state, action) => {
        state.districtDropdown_bil = typeof action.payload === "string" ? action.payload : "";
        state.schoolDropdown_bil = "";
      },
      schoolDropdown_bilUpdated: (state, action) => {
        state.schoolDropdown_bil = typeof action.payload === "string" ? action.payload : "";
      },
      CSEDate_bilUpdated: (state, action) => {
        let dateString = "";
        if (typeof action.payload === "string" || action.payload instanceof Date) {
          let temp = action.payload.toString().substring(0, 10);
          let temp2 = temp.split("-");
          if (temp2.length === 3) {
            dateString = temp2[0] + "-" + temp2[1] + "-" + temp2[2];
          }
        }
        state.CSEDate_bil = dateString;
      },
      currentTeacherName_bilUpdated: (state, action) => {
        state.currentTeacherName_bil = typeof action.payload === "string" ? action.payload : "";
      },
      currentTeacherEmail_bilUpdated: (state, action) => {
        state.currentTeacherEmail_bil = typeof action.payload === "string" ? action.payload : "";
      },
      psychologistName_bilUpdated: (state, action) => {
        state.psychologistName_bil = typeof action.payload === "string" ? action.payload : "";
      },
      psychologistEmail_bilUpdated: (state, action) => {
        state.psychologistEmail_bil = typeof action.payload === "string" ? action.payload : "";
      },
      speechPathologistName_bilUpdated: (state, action) => {
        state.speechPathologistName_bil = typeof action.payload === "string" ? action.payload : "";
      },
      speechPathologistEmail_bilUpdated: (state, action) => {
        state.speechPathologistEmail_bil = typeof action.payload === "string" ? action.payload : "";
      },
      districtContactName_bilUpdated: (state, action) => {
        state.districtContactName_bil = typeof action.payload === "string" ? action.payload : "";
      },
      districtContactTitle_bilUpdated: (state, action) => {
        state.districtContactTitle_bil = typeof action.payload === "string" ? action.payload : "";
      },
      districtContactAddress_bilUpdated: (state, action) => {
        state.districtContactAddress_bil = typeof action.payload === "string" ? action.payload : "";
      },
      districtContactPhone_bilUpdated: (state, action) => {
        state.districtContactPhone_bil = typeof action.payload === "string" ? action.payload : "";
      },
      districtContactEmail_bilUpdated: (state, action) => {
        state.districtContactEmail_bil = typeof action.payload === "string" ? action.payload : "";
      },
      approverName_bilUpdated: (state, action) => {
        state.approverName_bil = typeof action.payload === "string" ? action.payload : "";
      },
      approverTitle_bilUpdated: (state, action) => {
        state.approverTitle_bil = typeof action.payload === "string" ? action.payload : "";
      },
      approverEmail_bilUpdated: (state, action) => {
        state.approverEmail_bil = typeof action.payload === "string" ? action.payload : "";
      },
      coser_bilUpdated: (state, action) => {
        state.coser_bil = typeof action.payload === "string" ? action.payload : "";
      },
      reason_bilUpdated: (state, action) => {
        state.reason_bil = typeof action.payload === "string" ? action.payload : "";
      },
      alreadyClassified_bilUpdated: (state, action) => {
        state.alreadyClassified_bil = typeof action.payload === "boolean" ? action.payload : "";
      },
      classification_bilUpdated: (state, action) => {
        state.classification_bil = typeof action.payload === "string" ? action.payload : "";
      },
      consentToEvalAttached_billUpdated: (state, action) => {
        state.consentToEvalAttached_bill = typeof action.payload === "boolean" ? action.payload : false;
      },
      priorWrittenNoticeAttached_bilUpdated: (state, action) => {
        state.priorWrittenNoticeAttached_bil = typeof action.payload === "boolean" ? action.payload : false;
      },
      homeLangQuestAttached_bilUpdated: (state, action) => {
        state.homeLangQuestAttached_bil = typeof action.payload === "boolean" ? action.payload : false;
      },
      nonVerbSecDiagnosed_bilUpdated: (state, action) => {
        state.nonVerbSecDiagnosed_bil = typeof action.payload === "boolean" ? action.payload : false;
      },
      studentEnterSchoolDate_bilUpdated: (state, action) => {
        state.studentEnterSchoolDate_bil = typeof action.payload === "string" ? action.payload : "";
      },
      nameOfOtherSchoolAttended_bilUpdated: (state, action) => {
        state.nameOfOtherSchoolAttended_bil = typeof action.payload === "string" ? action.payload : "";
      },
      typesOfEvals_bilUpdated: (state, action) => {
        state.typesOfEvals_bil = Array.isArray(action.payload) ? action.payload : [];
      },
      typesOfEvals_other_bilUpdated: (state, action) => {
        state.typesOfEvals_other_bil = Array.isArray(action.payload) ? action.payload : [];
      },
      diagnosedCondition_bilUpdated: (state, action) => {
        state.diagnosedCondition_bil = typeof action.payload === "boolean" ? action.payload : "";
      },
      diagnosedConditionText_bilUpdated: (state, action) => {
        state.diagnosedConditionText_bil = typeof action.payload === "string" ? action.payload : "";
      },
      services_bilUpdated: (state, action) => {
        state.services_bil = Array.isArray(action.payload) ? action.payload : [];
      },
      generalHealth_bilUpdated: (state, action) => {
        state.generalHealth_bil = typeof action.payload === "boolean" ? action.payload : false;
      },
      generalHealthText_bilUpdated: (state, action) => {
        state.generalHealthText_bil = typeof action.payload === "string" ? action.payload : "";
      },
      medication_bilUpdated: (state, action) => {
        state.medication_bil = typeof action.payload === "boolean" ? action.payload : false;
      },
      medicationText_bilUpdated: (state, action) => {
        state.medicationText_bil = typeof action.payload === "string" ? action.payload : "";
      },
      wearsGlasses_bilUpdated: (state, action) => {
        state.wearsGlasses_bil = typeof action.payload === "boolean" ? action.payload : false;
      },
      wearsGlassesText_bilUpdated: (state, action) => {
        state.wearsGlassesText_bil = typeof action.payload === "string" ? action.payload : "";
      },
      pedRestrictions_bilUpdated: (state, action) => {
        state.pedRestrictions_bil = typeof action.payload === "boolean" ? action.payload : false;
      },
      pedRestrictionsText_bilUpdated: (state, action) => {
        state.pedRestrictionsText_bil = typeof action.payload === "string" ? action.payload : "";
      },
      physicalExamDate_bilUpdated: (state, action) => {
        let dateString = "";
        if (typeof action.payload === "string" || action.payload instanceof Date) {
          let temp = action.payload.toString().substring(0, 10);
          let temp2 = temp.split("-");
          if (temp2.length === 3) {
            dateString = temp2[0] + "-" + temp2[1] + "-" + temp2[2];
          }
        }
        state.physicalExamDate_bil = dateString;
      },
      h_freq_audiology_bilUpdated: (state, action) => {
        state.h_freq_audiology_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_indv_audiology_bilUpdated: (state, action) => {
        state.h_indv_audiology_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_freq_visTherapy_bilUpdated: (state, action) => {
        state.h_freq_visTherapy_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_indv_visTherapy_bilUpdated: (state, action) => {
        state.h_indv_visTherapy_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_freq_resourceRoom_bilUpdated: (state, action) => {
        state.h_freq_resourceRoom_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_indv_resourceRoom_bilUpdated: (state, action) => {
        state.h_indv_resourceRoom_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_freq_counseling_bilUpdated: (state, action) => {
        state.h_freq_counseling_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_indv_counseling_bilUpdated: (state, action) => {
        state.h_indv_counseling_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_freq_speechLang_bilUpdated: (state, action) => {
        state.h_freq_speechLang_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_indv_speechLang_bilUpdated: (state, action) => {
        state.h_indv_speechLang_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_freq_physTherapy_bilUpdated: (state, action) => {
        state.h_freq_physTherapy_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_indv_physTherapy_bilUpdated: (state, action) => {
        state.h_indv_physTherapy_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_freq_occTherapy_bilUpdated: (state, action) => {
        state.h_freq_occTherapy_bil = typeof action.payload === "string" ? action.payload : "";
      },
      h_indv_occTherapy_bilUpdated: (state, action) => {
        state.h_indv_occTherapy_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_Reading_bilUpdated: (state, action) => {
        state.i_freq_Reading_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_Reading_bilUpdated: (state, action) => {
        state.i_indv_Reading_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_AISMath_bilUpdated: (state, action) => {
        state.i_freq_AISMath_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_AISMath_bilUpdated: (state, action) => {
        state.i_indv_AISMath_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_AAtL_bilUpdated: (state, action) => {
        state.i_freq_AAtL_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_AAtL_bilUpdated: (state, action) => {
        state.i_indv_AAtL_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_AdjAssign_bilUpdated: (state, action) => {
        state.i_freq_AdjAssign_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_AdjAssign_bilUpdated: (state, action) => {
        state.i_indv_AdjAssign_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_schedAdj_bilUpdated: (state, action) => {
        state.i_freq_schedAdj_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_schedAdj_bilUpdated: (state, action) => {
        state.i_indv_schedAdj_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_indvProgBasedOnSkill_bilUpdated: (state, action) => {
        state.i_freq_indvProgBasedOnSkill_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_indvProgBasedOnSkill_bilUpdated: (state, action) => {
        state.i_indv_indvProgBasedOnSkill_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_speechImprov_bilUpdated: (state, action) => {
        state.i_freq_speechImprov_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_speechImprov_bilUpdated: (state, action) => {
        state.i_indv_speechImprov_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_tutoring_bilUpdated: (state, action) => {
        state.i_freq_tutoring_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_tutoring_bilUpdated: (state, action) => {
        state.i_indv_tutoring_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_freq_consulServices_bilUpdated: (state, action) => {
        state.i_freq_consulServices_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_indv_consulServices_bilUpdated: (state, action) => {
        state.i_indv_consulServices_bil = typeof action.payload === "string" ? action.payload : "";
      },
      i_other_bilUpdated: (state, action) => {
        state.i_other_bil = typeof action.payload === "string" ? action.payload : "";
      },
      areas_bilUpdated: (state, action) => {
        state.areas_bil = Array.isArray(action.payload) ? action.payload : [];
      },
      addConcerns_bilUpdated: (state, action) => {
        state.addConcerns_bil = typeof action.payload === "string" ? action.payload : "";
      },
      suspDetails_bilUpdated: (state, action) => {
        state.suspDetails_bil = typeof action.payload === "string" ? action.payload : "";
      },
      notes_bilUpdated: (state, action) => {
        state.notes_bil = typeof action.payload === "string" ? action.payload : "";
      },
      docToAccessFiles_bilUpdated: (state, action) => {
        state.docToAccessFiles_bil = Array.isArray(action.payload) ? action.payload : [];
      },
      consentToEvalAttachedFiles_bilUpdated: (state, action) => {
        state.consentToEvalAttachedFiles_bil = Array.isArray(action.payload) ? action.payload : [];
      },
      priorWrittenNoticeAttachedFiles_bilUpdated: (state, action) => {
        state.priorWrittenNoticeAttachedFiles_bil = Array.isArray(action.payload) ? action.payload : [];
      },
      homeLangQuestAttachedFiles_bilUpdated: (state, action) => {
        state.homeLangQuestAttachedFiles_bil = Array.isArray(action.payload) ? action.payload : [];
      },

      page1ProgressBarUpdated: (state, action) => {
        let tempVal = 0;
        if (state.studentFirstName_bil.length > 0){
                tempVal += 8;
        }
        if (state.studentLastName_bil.length > 0){
            tempVal += 8;
        }
        if (state.DOB_bil.length > 0){
            tempVal += 8;
        }
        if (state.nativeLanguage_bil == "Other"){
            if (state.nativeLanguageOther_bil.length > 0) tempVal += 8;
        }
        else if (state.nativeLanguage_bil.length > 0 && state.nativeLanguage_bil != "Other"){
            tempVal += 8;
        }
        if (state.coser_bil.length > 0 || state.districtDropdown_bil != "Nassau BOCES"){
            tempVal += 4;
        }
        if (state.grade_bil.length > 0){
            tempVal += 8;
        }
        if (state.districtDropdown_bil.length > 0){
            tempVal += 8;
        }
        if (state.schoolDropdown_bil.length > 0){
            tempVal += 8;
        }
        if (state.childResidesWith_bil.length > 0 && state.childResidesWith_bil != "Other"){
            tempVal += 8;
        }
        else if (state.childResidesWith_bil == "Other" && state.childsResidesWithOther_bil.length > 0){
            tempVal += 8;
        }
        if (state.mfg1_bil.length > 0){
            tempVal += 8;
        }
        if (state.mfgName1_bil.length > 0){
            tempVal += 8;
        }
        if (state.homeAddress_bil.length > 0){
            tempVal += 8;
        }
        if (state.homeNum_bil.length > 0){
            tempVal += 8;
        }
        
        state.page1ProgressBar = Math.min(tempVal,100);
      },
      page2ProgressBarUpdated: (state, action) => {
        let tempVal = 0;
        if (state.CSEDate_bil.length > 0){
            tempVal += 8;
        }
        if (state.psychologistName_bil.length > 0){
            tempVal += 8;
        }
        if (state.psychologistEmail_bil.length > 0){
            tempVal += 8;
        }
        if (state.speechPathologistName_bil.length > 0){
            tempVal += 8;
        }
        if (state.speechPathologistEmail_bil.length > 0){
            tempVal += 8;
        }
        if (state.districtContactName_bil.length > 0){
            tempVal += 8;
        }
        if (state.districtContactTitle_bil.length > 0){
            tempVal += 8;
        }
        if (state.districtContactAddress_bil.length > 0){
            tempVal += 8;
        }
        if (state.districtContactPhone_bil.length > 0){
            tempVal += 8;
        }
        if (state.districtContactEmail_bil.length > 0){
            tempVal += 7;
        }
        if (state.approverName_bil.length > 0){
            tempVal += 7;
        }
        if (state.approverTitle_bil.length > 0){
            tempVal += 7;
        }
        if (state.approverEmail_bil.length > 0){
            tempVal += 7;
        }

        state.page2ProgressBar = Math.min(tempVal,100);
      },
      page3ProgressBarUpdated: (state, action) => {
        let tempVal = 0;
        if (state.services_bil.length > 0){
            tempVal += 9;
        }
        if (state.reason_bil.length > 0){
            tempVal += 9;
        }



        if (state.studentEnterSchoolDate_bil.length > 0){
            tempVal += 9;
        }

        
        if (state.diagnosedCondition_bil && state.diagnosedConditionText_bil.length > 0){
            tempVal += 9;
        }
        else if (!state.diagnosedCondition_bil){
            tempVal += 9;
        }

        if (state.generalHealth_bil && state.generalHealthText_bil.length > 0){
            tempVal += 9;
        }
        else if (!state.generalHealth_bil){
            tempVal += 9;
        }
        // Medication
        if (state.medication_bil && state.medicationText_bil.length > 0){
            tempVal += 9;
        }
        else if (!state.medication_bil){
            tempVal += 9;
        }
        // Wears Glasses
        if (state.wearsGlasses_bil && state.wearsGlassesText_bil.length > 0){
            tempVal += 9;
        }
        else if (!state.wearsGlasses_bil){
            tempVal += 9;
        }
        // PED Restrictions
        if (state.pedRestrictions_bil && state.pedRestrictionsText_bil.length > 0){
            tempVal += 9;
        }
        else if (!state.pedRestrictions_bil){
            tempVal += 9;
        }

        if (state.physicalExamDate_bil.length > 0){
            tempVal += 9;
        }

        
        if (state.areas_bil.length > 0){
            tempVal += 9;
        }

        if (state.suspDetails_bil.length > 0){
            tempVal += 10;
        }

        state.page3ProgressBar = Math.min(tempVal,100);

      },
      backToInitialValuesUpdated_bil: (state, action) => {
            state.studentFirstName_bil= '';
            state.studentLastName_bil = '';
            state.countryOfOrigin_bil = '';
            state.DOB_bil = '';
            state.gender_bil = '';
            state.yearsInUS_bil = '';
            state.grade_bil = '';
            state.childResidesWith_bil = '';
            state.mfg1_bil = '';
            state.mfgName1_bil = '';
            state.mfg2_bil = '';
            state.mfgName2_bil = '';
            state.childsResidesWithOther_bil = '';
            state.homeAddress_bil = '';
            state.homeNum_bil = '';
            state.workNum_bil = '';
            state.cellNum_bil = '';
            state.nativeLanguage_bil = '';
            state.nativeLanguageOther_bil = '';
            state.districtDropdown_bil = '';
            state.schoolDropdown_bil = '';
            state.CSEDate_bil = '';
            state.currentTeacherName_bil = '';
            state.currentTeacherEmail_bil = '';
            state.psychologistName_bil = '';
            state.psychologistEmail_bil = '';
            state.speechPathologistName_bil = '';
            state.speechPathologistEmail_bil = '';
            state.districtContactName_bil = '';
            state.districtContactTitle_bil = '';
            state.districtContactAddress_bil = '';
            state.districtContactPhone_bil = '';
            state.districtContactEmail_bil = '';
            state.approverName_bil = '';
            state.approverTitle_bil = '';
            state.approverEmail_bil = '';
            state.coser_bil = '';
            state.reason_bil = '';
            state.alreadyClassified_bil = '';
            state.classification_bil = '';

            state.consentToEvalAttached_bill = false;
            state.priorWrittenNoticeAttached_bil = false;
            state.homeLangQuestAttached_bil = false;
            state.nonVerbSecDiagnosed_bil = false;
            
            state.services_bil = [];
            state.notes_bil = '';
            state.studentEnterSchoolDate_bil = '';
            state.nameOfOtherSchoolAttended_bil = '';
            state.typesOfEvals_bil = [];
            state.typesOfEvals_other_bil = [];
            state.diagnosedCondition_bil = '';
            state.diagnosedConditionText_bil = '';
            state.generalHealth_bil = false;
            state.generalHealthText_bil = '';
            state.medication_bil = false;
            state.medicationText_bil = '';
            state.wearsGlasses_bil = false;
            state.wearsGlassesText_bil = '';
            state.pedRestrictions_bil = false;
            state.pedRestrictionsText_bil = '';
            state.physicalExamDate_bil = '';
            state.h_freq_audiology_bil = '';
            state.h_indv_audiology_bil = '';
            state.h_freq_visTherapy_bil = '';
            state.h_indv_visTherapy_bil = '';
            state.h_freq_resourceRoom_bil = '';
            state.h_indv_resourceRoom_bil = '';
            state.h_freq_counseling_bil = '';
            state.h_indv_counseling_bil = '';
            state.h_freq_speechLang_bil = '';
            state.h_indv_speechLang_bil = '';
            state.h_freq_physTherapy_bil = '';
            state.h_indv_physTherapy_bil = '';
            state.h_freq_occTherapy_bil = '';
            state.h_indv_occTherapy_bil = '';
            state.i_freq_Reading_bil = '';
            state.i_indv_Reading_bil = '';
            state.i_freq_AISMath_bil = '';
            state.i_indv_AISMath_bil = '';
            state.i_freq_AAtL_bil = '';
            state.i_indv_AAtL_bil = '';
            state.i_freq_AdjAssign_bil = '';
            state.i_indv_AdjAssign_bil = '';
            state.i_freq_schedAdj_bil = '';
            state.i_indv_schedAdj_bil = '';
            state.i_freq_indvProgBasedOnSkill_bil = '';
            state.i_indv_indvProgBasedOnSkill_bil = '';
            state.i_freq_speechImprov_bil = '';
            state.i_indv_speechImprov_bil = '';
            state.i_freq_tutoring_bil = '';
            state.i_indv_tutoring_bil = '';
            state.i_freq_consulServices_bil = '';
            state.i_indv_consulServices_bil = '';
            state.i_other_bil = '';
            state.areas_bil = [];
            state.addConcerns_bil = '';
            state.suspDetails_bil = '';

            state.docToAccessFiles_bil = [];
            state.consentToEvalAttachedFiles_bil = [];
            state.priorWrittenNoticeAttachedFiles_bil = [];
            state.homeLangQuestAttachedFiles_bil = [];

            state.page1ProgressBar = 0;
            state.page2ProgressBar = 0;
            state.page3ProgressBar = 0;
        },
    },
});

export const { backToInitialValuesUpdated_bil, page1ProgressBarUpdated, page2ProgressBarUpdated, page3ProgressBarUpdated, studentFirstName_bilUpdated, studentLastName_bilUpdated, countryOfOrigin_bilUpdated, DOB_bilUpdated, gender_bilUpdated, yearsInUS_bilUpdated, grade_bilUpdated, childResidesWith_bilUpdated, mfg1_bilUpdated, mfgName1_bilUpdated, mfg2_bilUpdated, mfgName2_bilUpdated, childsResidesWithOther_bilUpdated, homeAddress_bilUpdated, homeNum_bilUpdated, workNum_bilUpdated, cellNum_bilUpdated, nativeLanguage_bilUpdated, nativeLanguageOther_bilUpdated, districtDropdown_bilUpdated, schoolDropdown_bilUpdated, CSEDate_bilUpdated, currentTeacherName_bilUpdated, currentTeacherEmail_bilUpdated, psychologistName_bilUpdated, psychologistEmail_bilUpdated, speechPathologistName_bilUpdated, speechPathologistEmail_bilUpdated, districtContactName_bilUpdated, districtContactTitle_bilUpdated, districtContactAddress_bilUpdated, districtContactPhone_bilUpdated, districtContactEmail_bilUpdated, approverName_bilUpdated, approverTitle_bilUpdated, approverEmail_bilUpdated, coser_bilUpdated, reason_bilUpdated, alreadyClassified_bilUpdated, classification_bilUpdated, consentToEvalAttached_billUpdated, priorWrittenNoticeAttached_bilUpdated, homeLangQuestAttached_bilUpdated, nonVerbSecDiagnosed_bilUpdated, studentEnterSchoolDate_bilUpdated, nameOfOtherSchoolAttended_bilUpdated, typesOfEvals_bilUpdated, typesOfEvals_other_bilUpdated, diagnosedCondition_bilUpdated, diagnosedConditionText_bilUpdated, services_bilUpdated, generalHealth_bilUpdated, generalHealthText_bilUpdated, medication_bilUpdated, medicationText_bilUpdated, wearsGlasses_bilUpdated, wearsGlassesText_bilUpdated, pedRestrictions_bilUpdated, pedRestrictionsText_bilUpdated, physicalExamDate_bilUpdated, h_freq_audiology_bilUpdated, h_indv_audiology_bilUpdated, h_freq_visTherapy_bilUpdated, h_indv_visTherapy_bilUpdated, h_freq_resourceRoom_bilUpdated, h_indv_resourceRoom_bilUpdated, h_freq_counseling_bilUpdated, h_indv_counseling_bilUpdated, h_freq_speechLang_bilUpdated, h_indv_speechLang_bilUpdated, h_freq_physTherapy_bilUpdated, h_indv_physTherapy_bilUpdated, h_freq_occTherapy_bilUpdated, h_indv_occTherapy_bilUpdated, i_freq_Reading_bilUpdated, i_indv_Reading_bilUpdated, i_freq_AISMath_bilUpdated, i_indv_AISMath_bilUpdated, i_freq_AAtL_bilUpdated, i_indv_AAtL_bilUpdated, i_freq_AdjAssign_bilUpdated, i_indv_AdjAssign_bilUpdated, i_freq_schedAdj_bilUpdated, i_indv_schedAdj_bilUpdated, i_freq_indvProgBasedOnSkill_bilUpdated, i_indv_indvProgBasedOnSkill_bilUpdated, i_freq_speechImprov_bilUpdated, i_indv_speechImprov_bilUpdated, i_freq_tutoring_bilUpdated, i_indv_tutoring_bilUpdated, i_freq_consulServices_bilUpdated, i_indv_consulServices_bilUpdated, i_other_bilUpdated, areas_bilUpdated, addConcerns_bilUpdated, suspDetails_bilUpdated, notes_bilUpdated, docToAccessFiles_bilUpdated, consentToEvalAttachedFiles_bilUpdated, priorWrittenNoticeAttachedFiles_bilUpdated, homeLangQuestAttachedFiles_bilUpdated } = assessmentSlice.actions;

export default assessmentSlice.reducer;